import { z } from 'zod';

export const searchSchema = z.object({
  // Basic fields - using field names from DieuKienThanhToanInput
  ma_dk: z.string().min(1, 'Mã điều kiện là bắt buộc'), // Payment condition code
  ten_dk: z.string().min(1, 'Tên điều kiện là bắt buộc'), // Payment condition name
  ten_dk2: z.string().optional().nullable(), // Alternative name
  loai_dk: z.string().default('1'), // Type of payment condition, default to '1'
  // General tab fields
  ngay_gom_hd1: z.coerce.number().optional().nullable(), // First invoice grouping day
  ngay_gom_hd2: z.coerce.number().optional().nullable(), // Second invoice grouping day
  ngay_tt_thang: z.string().optional().nullable(), // Payment day of the month (changed to string to match backend)
  ngay_tt_tuan: z.string().optional().nullable(), // Day of week (for loai_dk = '2')
  tuan_tt_thu: z.string().optional().nullable(), // Week number (for loai_dk = '2')
  so_ngay: z.coerce.number().default(0), // Number of days for payment term
  status: z.string().default('1') // Status, default to '1' (In use)
});
export type SearchFormValues = z.infer<typeof searchSchema>;

export const initialValues: SearchFormValues = {
  ma_dk: '',
  ten_dk: '',
  ten_dk2: null,
  loai_dk: '1', // Default to '1' (Fixed day of month)
  // General tab fields
  ngay_gom_hd1: 0,
  ngay_gom_hd2: 0,
  ngay_tt_thang: '1', // Default to day 1 (changed to string to match backend)
  ngay_tt_tuan: '1', // Default to Sunday (Chủ nhật)
  tuan_tt_thu: '1', // Default to Week 1
  so_ngay: 0,
  status: '1' // Default to '1' (In use)
};
